const PRIORITY_ICON = {
  HIGH: 'icon-sgs12',
  LOW: 'icon-sgs5'
};
export const SVG_ICON_NAME = {
  _3PL: '3PL',
  SWAP: 'SWAP',
  dailyPickup: 'dailyPickup',
  ExcessiveLength: 'ExcessiveLength',
  RESUNA: 'RESUNA',
  DockDrop: 'Drop',
  COD: 'COD',
  ExhibitPickup: 'ExhibitPickup',
  TwoMan: '2Man',
  CargoVan: 'CargoVan',
  TrailerBackFill: 'TrailerBackFill',
  LiftGateOverride: 'LiftGateOverride',
  TrailerSwap: 'TrailerSwap',
  LiveUnload: 'LiveUnload',
  Hold: 'Hold',
  HoldRM: 'HoldRM',
  CustomerComments: 'CustomerComments',
  ShipperComments: 'ShipperComments',
  TrailerLength: 'TrailerLength',
  DOW: 'DOW',
  WhiteGloveDelivery: 'WhiteGloveDelivery',
  NINV: 'NINV',
  PhysicalDR: 'PhysicalDR',
  ADN: 'ADN',
  TailLoad: 'TailLoad',
  Fresh: 'Fresh',
  Heat: 'Heat',
  Frozen: 'Frozen'
};

export const HTTP_METHOD = {
  GET: 'GET',
  POST: 'POST'
};

export const USER_ROLE = {
  PLANNER: 'planner',
  DISPATCHER: 'dispatcher',
  ADMIN: 'admin',
  MANAGER: 'manager',
  READ_ONLY: 'read-only'
};

export const CLIENT_NAMES = {
  SAIA: 'SAIA'
};

export const SESSION_STORAGE_KEYS = {
  ACTIVE_SETTINGS_MODULE: 'activeSettingsModule'
};

export const EVENT_TYPES = {
  SETTINGS: {
    MODULE_CHANGE: 'settingsModuleChange'
  }
};

const gridNames = {
  ShipmentsGrid: 'ShipmentsGrid',
  IBShipmentsGrid: 'IBShipmentsGrid',
  CustomerGrid: 'CustomerGrid',
  ShipperGrid: 'ShipperGrid',
  RoutesGrid: 'RoutesGrid',
  StopsGrid: 'StopsGrid',
  TrailerInventory: 'TrailerInventory',
  AnchorPoint: 'AnchorPoint',
  Parameters: 'Parameters',
  StemMiles: 'StemMiles',
  ZoneMiles: 'ZoneMiles',
  TerminalAccess: 'TerminalAccess',
  FeederTerminal: 'FeederTerminal',
  AccessibleTerminal: 'AccessibleTerminal',
  ScenarioExplorer: 'ScenarioExplorer',
  AnchorPointGrid: 'AnchorPointGrid',
  UNRTDShipments: 'UNRTDShipments',
  KPIGoals: 'KPIGoals',
  IBPlanningSummary: 'IBPlanningSummary',
  DriverPreferences: 'DriverPreferences',
  RouteEquipmentPreference: 'RouteEquipmentPreference',
  ProHistory: 'ProHistory',
  DockCompliance: 'DockCompliance',
  NextStopCompliance: 'NextStopCompliance',
  AssetManagement: 'AssetManagement',
  DispatchedDriverGrid: 'DispatchedDriverGrid',
  PickupOptimizationSelectDriversGrid: 'PickupOptimizationSelectDriversGrid',
  DispatchQuickFilter: 'DispatchQuickFilter',
  PickupsGrid: 'PickupsGrid',
  DriverInfoGrid: 'DriverInfoGrid',
  ScheduleGrid: 'ScheduleGrid',
  DispatchPickupInfoGrid: 'DispatchPickupInfoGrid',
  DispatchPickupHistoryGrid: 'DispatchPickupHistoryGrid',
  DispatchGroupMsg: 'DispatchGroupMsg',
  DuplicateCustomerGrid: 'DuplicateCustomerGrid',
  MergedCustomerGrid: 'MergedCustomerGrid',
  ReturnsGrid: 'ReturnsGrid',
  IBbillsGrid: 'IBbillsGrid',
  DueBillsGrid: 'DueBillsGrid',
  ShipmentsEventStream: 'ShipmentsEventStream',
  AddNewShipmentsGrid: 'AddNewShipmentsGrid',
  TrailerStripPriorityGrid: 'IB Trailer Strip Priority',
  TrailerShipmentsGrid: 'TrailerShipmentsGrid',
  EquipmentDefectGrid: 'EquipmentDefectGrid',
  DollyGrid: 'DollyGrid',
  TractorGrid: 'TractorGrid',
  TrailersGrid: 'TrailersGrid',
  PriorityShipmentsGrid: 'PriorityShipmentsGrid',
  LoadingGuide: 'LoadingGuide',
  dynamicRoutingRoutesSummary: 'dynamicRoutingRoutesSummary',
  LgTrailerValidationGrid: 'LgTrailerValidationGrid',
  DuplicateCustomerValidationGrid: 'DuplicateCustomerValidationGrid',
  IncorrectPseValidationGrid: 'IncorrectPseValidationGrid',
  LateShipmentValidationGrid: 'LateShipmentValidationGrid',
  DistantShipmentValidationGrid: 'DistantShipmentValidationGrid',
  UnappointedProsValidationGrid: 'UnappointedProsValidationGrid',
  shipmentForecastTerminalCustomers: 'shipmentForecastTerminalCustomers',
  shipmentForecastTerminalBills: 'shipmentForecastTerminalBills',
  shipmentForecastNetworkCustomers: 'shipmentForecastNetworkCustomers',
  shipmentForecastNetworkBills: 'shipmentForecastNetworkBills',
  optimizationDriverPreferences: 'optimizationDriverPreferences',
  routeAuditRoutes: 'routeAuditRoutes',
  routeAuditShipments: 'routeAuditShipments',
  ClosedTrailersGrid: 'ClosedTrailersGrid',
  TrailerMovesGrid: 'TrailerMovesGrid'
};

const appConstants = {
  layout: {
    ShipmentsMap: 'ShipmentsMap',
    RoutesMap: 'RoutesMap',
    SettingsPage: 'SettingsPage',
    QuickFilter: 'QuickFilter',
    KPIPanel: 'KPIPanel',
    Reports: 'Reports',
    DispatchDriversMap: 'DispatchDriversMap',
    CustomerMap: 'CustomerMap',
    CustomerQuickFilter: 'CustomerQuickFilter'
  },
  columnTypes: {
    STRING: 'string',
    NUMBER: 'number',
    DOUBLE: 'double',
    DATE: 'date',
    TIME: 'time',
    BOOLEAN: 'boolean',
    PERCENTAGE: 'percentage',
    TEXT: 'text',
    DATETIME: 'datetime'
  },
  gridNames: gridNames,
  mapIds: {
    CUSTOMER_MAP: 'customerMap',
    EDIT_CUSTOMER_MAP: 'editCustomerMap',
    DISPATCH_MAP: 'dispatchMap',
    SHIPMENTS_MAP: 'shipmentsMap',
    ROUTES_MAP: 'routesMap',
    PICKUPS_MAP: 'pickupsMap',
    SELECT_DRIVERS_MAP: 'selectDriversMap',
    PICKUP_OPTIMIZATION_ROUTE_MAP: 'routeMap',
    GEO_CODING_MAP: 'geoCodingMap',
    ANCHOR_POINT_MAP: 'anchorPointMap',
    STOP_LOCATION_MAP: 'StopLocationMap',
    NEXT_STOP_COMPLIANCE_MAP: 'NextStopMap',
    ROUTE_MAPPING_TOOL_MAP: 'RouteMappingToolMAP',
    RECORDS_LOOKUP_ROUTE_MAP: 'recordsLookupRouteMap',
    TRAILER_MAP: 'TrailerMap',
    ONBOARD_TERMINAL_MAP: 'OnboardTerminalMap'
  },
  KPI_NAME: {
    DispatchKPI: 'DispatchKPI'
  },
  mapName: {
    DispatchMap: 'DispatchMap',
    RoutesMap: 'RoutesMap'
  },
  Map: 'Google', // defined which MAP should be used as Map Component
  columnWidth: {
    TERMINAL: 120,
    PROID: 125,
    TRAP: 130,
    CUBE: 130,
    ROUTES: 95,
    ROUTE_MODE: 65,
    DRIVER_ROUTE: 125,
    MAX_TRAILER: 120,
    FIXED_TRAILER: 140,
    IBETA: 145,
    LG: 73,
    REGION_ID: 150,
    PIECES: 120,
    HU: 100,
    GEOCODING: 110,
    ALIASES: 200,
    WEIGHT: 120,
    SERVICE_LEVEL: 120,
    TOTAL_PIECES: 120,
    AREA: 83,
    DUE_DATE: 115,
    DELIVERY_WINDOW: 200,
    EARLY_LATE_CTA: 150,
    PICKUP_WINDOW: 180,
    CUSTOMER: 190,
    CUSTOMER_CODE: 150,
    RETURN_CODE: 150,
    CUSTOMER_ADDRESS: 180,
    EQUIPMENT_PREFERENCE: 115,
    TRAILER_ID: 120,
    MANIFEST_ID: 128,
    LOCK_STATUS: 90,
    TOTAL_STOPS: 104,
    PROS: 120,
    TRAILER_TYPE: 120,
    LIFT_GATE: 120,
    TOTAL_MILES: 103,
    TOTAL_TIME: 100,
    EMPTY_TIME: 122,
    DRIVER_NAME: 100,
    TRIPS: 130,
    TOTAL_COST: 120,
    LOADCLOSE_TIME: 147,
    START_TIME: 113,
    TRACTOR_ID: 140,
    ANCHORPOINT_NAME: 128,
    COMMENTS: 117,
    ISSTATIC_ROUTE: 170,
    STOP_SEQUENCE: 110,
    CONSIGNEE_ID: 170,
    CONSIGNEE_NAME: 190,
    ZIP_CODE: 85,
    APPOINTMENT: 120,
    LATITUDE: 160,
    LONGITUDE: 160,
    ROUTE_STOP_ID: 170,
    STOP_TYPE: 150,
    STOP_TIME: 150,
    TOTAL_BILLS: 95,
    STOP_STATUS: 120,
    SPECIAL_INSTRUCTION: 140,
    ETA: 80,
    ETD: 80,
    ROUTES_NAME: 110,
    ROUTEID: 150,
    INPLAN: 95,
    CITY: 140,
    SHIPPER_STATE: 132,
    STATE: 87,
    CUBIC_FEET: 115,
    WAVE: 87,
    PREP_TIME: 112,
    SHIPMENT_STATUS: 147,
    CITY_STATUS: 110,
    RETURN_REASON: 139,
    LOADED_BILLS: 120,
    PRO_COUNT: 110,
    APT: 76,
    PRIORITY: 98,
    SPL_NEED: 130,
    PICKUP_TYPE: 110,
    BILLS: 80,
    LDG_ZONE: 108,
    ILINE: 90,
    ORDER_NUMBER: 125,
    PARAMETER: 500,
    PARAM_DEFAULT: 200,
    PARAM_CUSTOM: 200,
    SPEED_MILES_RANGE: 200,
    SPEED_MILES_VALUE: 200,
    PACKAGE_TYPE: 130,
    PALLET_COUNT: 125,
    PSE: 80,
    CALCULATED_PSE: 140,
    VIOLATION_DOT: 20,
    AP_STATUS: 90,
    AP_NAME: 180,
    AP_EMPTYTIME: 90,
    AP_STARTTIME: 90,
    AP_ROUTE: 200,
    SCENARIO_ID: 100,
    PRO_ID: 200,
    APT_DUE_DATE: 132,
    PKG_TYPE: 100,
    ACC_HRS: 95,
    ACC_HRS_132: 132,
    WEEKLY_ACC_HRS: 140,
    DISPATCH_DRIVER_NAME: 180,
    STATUS: 120,
    UNOCC_TRAILER_SPACE: 180,
    TOTAL_HU: 110,
    DELIVERIES_GROUP: 120,
    PICKUPS_GROUP: 120,
    ASSIGN_ACTION: 130,
    ROUTE_NAME: 120,
    PICKUP_DATE: 120,
    DISPATCH_IBOB_TERMINAL: 130,

    FEEDER_TERMINAL: 400,
    REGION: 80,
    DIVISION: 80,
    ACCESSIBLE_TERMINAL: 180,
    ACTION: 130,

    TERMINAL_USER: 190,
    TERMINAL_FIRSTNAME: 115,
    TERMINAL_LASTNAME: 115,
    TERMINAL_EMAIL: 250,
    TERMINAL_JOBTITLE: 150,
    TERMINAL_DEFAULTTERMINAL: 150,
    TERMINAL_TERMINALLIST: 200,
    TERMINAL_COMMANDS: 130,

    KPI_NAME: 150,
    KPI_VALUE: 150,

    NOTIFICATION_TYPE: 120,
    NOTIFICATION_MESSAGE: 200,
    NOTIFICATION_LINK: 100,
    NOTIFICATION_ISCLOSABLE: 100,
    NOTIFICATION_ISACTIVE: 100,
    NOTIFICATION_COMMAND: 120,

    //Dock Compliance Report
    DCR_COMPLIANCE: 100,
    DCR_ROUTETYPE: 80,
    DCR_COMPLIANCE_PROUTE: 130,
    DCR_COMPLIANCE_UNPL: 140,
    DCR_COMPLIANCE_DROUTE: 150,
    DCR_COMPLIANCE_MATCHED: 125,
    DCR_COMPLIANCE_MANIFEST: 120,

    REPORTS_TERMINALCODE: 100,
    REPORTS_TERMINALNAME: 140,
    REPORTS_REGION: 90,
    REPORTS_DIVISION: 120,
    REPORTS_PROCOUNT: 90,
    REPORTS_PUBLISHCOUNT: 90,
    REPORTS_ROUTECOUNT: 90,
    REPORTS_FIRSTPUSH: 120,
    REPORTS_FIRSTPUBLISH: 125,
    REPORTS_LASTPUBLISH: 130,
    REPORTS_PRO_CHANGED_BY: 250,
    REPORTS_USER: 180,

    DUPLICATE_CUSTOMERS_ROUTE: 100,
    DUPLICATE_CUSTOMERS_CUSTOMER: 120,
    DUPLICATE_CUSTOMERS_ADDRESS: 200,
    DUPLICATE_CUSTOMERS_CITY: 100,
    DUPLICATE_CUSTOMERS_DELIVERY_WINDOW: 140,

    DP_DRIVERID: 350,
    DP_DRIVERNAME: 150,
    DP_STARTTIME: 150,
    DP_ZONE: 100,
    ROUTE_EQMT_MAP_ROUTE: 150,
    ROUTE_EQMT_MAP_TRAILER: 150,

    HOLIDAY_NAME: 120,

    DISPATCH_TRAILER: 110,
    DISPATCH_MANIFEST: 120,
    DISPATCH_TRAILER_TYPE: 120,
    DISPATCH_TRAILER_STATUS: 140,
    DISPATCH_TRAILER_CLASS: 80,
    DISPATCH_TRACTOR: 120,
    DISPATCH_DRIVER_STATUS: 260,
    DISPATCH_ROUTE_NAME: 120,
    DISPATCH_ACTION: 140,
    DISPATCH_ZONE: 150,
    DISPATCH: 120,
    PICKUP_NUMBER: 140,
    MERGED_PICKUP_ICON: 50,
    PRO_NUMBER: 140,
    DRIVER_NUMBER: 140,
    DRIVER_TYPE: 110,
    DRIVER_ZONE: 150,
    DRIVER_DRIVER_NAME: 200,
    DRIVER_CALL_TIME: 150,
    DRIVER_SCHEDULED_TIME: 150,
    DRIVER_SCHEDULED_DATE: 150,
    DRIVER_ADDRESS: 250,
    DRIVER_STATUS: 200,
    PHONE_NUMBER: 200,

    DRIVER_INFO: 140,
    DRIVER_INFO_SMALL: 80,
    CUSTOMER_NAME: 250,
    STOPS: 100,
    ARRIVAL_TIME: 130,
    EXPECTED_DEPARTURE_TIME: 130,
    OCC_PSE: 130,

    OPTIMIZATION_PICKUP_NAME: 220,
    OPTIMIZATION_DELIVERY_WINDOW: 100,
    OPTIMIZATION_PSE: 80,

    DISPATCH_GROUP_MSG_TIME: 115,
    DISPATCH_GROUP_MSG_FROM: 130,
    DISPATCH_GROUP_MSG_TO: 140,
    DISPATCH_GROUP_MSG_MESSAGE: 400,

    NEXT_STOP_COMPLIANCE_ROUTE: 160,
    NEXT_STOP_COMPLIANCE_DRIVER_NAME: 190,
    NEXT_STOP_COMPLIANCE_MANIFEST: 130,
    NEXT_STOP_COMPLIANCE_TOTAL_TIME: 120,

    DATE_TIME: 130,
    CLOSE_TIME: 115,
    ETA_TIME: 90,
    ELAPSE_TIME: 130,
    LAST_ACTIVE_TIME: 130,

    EQUIPMENT: 110,
    CATEGORY: 100,
    SUB_CATEGORY: 100,
    DEFECT: 200,
    SEVERITY: 60,
    DEFECT_DATE: 80,

    //we may need to use different width for same field in different grids. we can do this by using below values .
    W_30: 30,
    W_40: 40,
    W_50: 50,
    W_60: 60,
    W_62: 62,
    W_64: 64, //Revert it to W_62 for dynamic routing checkbox column, as of now we are getting style overl lapping issue, show three dots in ui, to fix this we are using W_64
    W_65: 65,
    W_70: 70,
    W_80: 80,
    W_85: 85,
    W_90: 90,
    W_95: 95,
    W_100: 100,
    W_110: 110,
    W_115: 115,
    W_120: 120,
    W_125: 125,
    W_130: 130,
    W_140: 140,
    W_150: 150,
    W_160: 160,
    W_170: 170,
    W_180: 180,
    W_200: 200,
    W_240: 240,
    W_250: 250,
    W_260: 260,
    W_300: 300
  },
  routeDisplayColorOptions: [
    '#17d097',
    '#ff2989',
    '#af2ce5',
    '#a7a7a7',
    '#4da75e',
    '#ff8b24',
    '#45a8ee',
    '#88d41b',
    '#ee5145',
    '#c68870',
    '#00742a',
    '#950074',
    '#b588ff',
    '#5eadb0',
    '#921500',
    '#00636c',
    '#6e7800',
    '#6434ff',
    '#ff8fc1'
  ],
  Event: {
    ROUTE_SELECTED: 'routeSelected',
    STOP_SELECTED_MAP: 'stopSelectedOnMap',
    STOP_SELECTED_GRID: 'stopSelectedOnGrid',
    SHIPMENT_SELECTED_GRID: 'ShipmentSelectedOnGrid',
    PICKUP_SELECTED_GRID: 'pickupSelectedOnGrid',
    PICKUP_SELECTED_MAP: 'selectedPickupChangedOnMap',
    SELECT_PICKUP_ROUTES: 'selectPickupRoutes',
    DISPATCH_ROUTE_SELECTED: 'dispatchRouteSelected',
    SHIPMENT_SELECTED_MAP: 'ShipmentSelectedOnMap',
    STOP_UPDATE_SEQUENCE: 'updateStopSequence',
    SHIPMENT_FILTERED_GRID: 'ShipmentFilteredonGrid',
    CLOSE_LASSO_PANEL: 'CloseLassoPanel',
    RESTOREIBSTORE: 'RestoreIBStore',
    SHIPMENT_SELECTION_COMPLETED: 'ShipmentSelectionCompleted'
  },
  LockStates: [
    { value: 0, text: 'Unlock', icon: 'icon-lock-open' },
    { value: 1, text: 'Partial-lock', icon: 'icon-lock-open-alt' },
    { value: 2, text: 'Lock', icon: 'icon-lock' }
  ],
  geoCode: [
    {
      value: true,
      text: 'GeoCoded',
      icon: 'icon-geoCoded'
    },
    {
      value: false,
      text: 'Not GeoCoded',
      icon: 'icon-notGeoCoded'
    }
  ],
  geoFenced: [
    {
      value: 1,
      text: 'GeoFenced',
      icon: ''
    },
    {
      value: 0,
      text: 'Not GeoFenced',
      icon: ''
    }
  ],
  BooleanFilter: [
    {
      value: true,
      text: 'Yes'
    },
    {
      value: false,
      text: 'No'
    }
  ],
  SpecialNeeds: [
    {
      value: 'EQS',
      text: 'Equipment Size',
      svgIcon: SVG_ICON_NAME.TrailerLength,
      tooltip: 'Equipment Size Requirements'
    },
    { value: 'APT', text: 'APT', icon: 'icon-apt', tooltip: 'APT shipment' },
    { value: 'L', text: 'LG', icon: 'icon-liftgate', tooltip: 'LG Required' },
    { value: 'Pup', text: 'PUP', icon: 'icon-pup', tooltip: 'PUP Required' },
    {
      value: 'PupLG',
      text: 'PUP LG',
      icon: 'icon-pup',
      tooltip: 'PUP LG Required'
    },
    {
      value: 'StraightTruck',
      text: 'Bobtail/ ST',
      icon: 'icon-truck-1',
      tooltip: 'Bobtail/Small Truck Required'
    },
    {
      value: 'StraightTruckLG',
      text: 'Bobtail/ ST LG',
      icon: 'icon-truck-1',
      tooltip: 'Bobtail/Small Truck LG Required'
    },
    { value: 'PZ', text: 'Poison', icon: 'icon-issue', tooltip: 'Poison' },
    { value: 'HZ', text: 'Hazard', icon: 'icon-hazmat', tooltip: 'Hazmat' },
    { value: 'FD', text: 'Food', icon: 'icon-food', tooltip: 'Food' },
    { value: 'FZ', text: 'Freezable', icon: 'icon-freeze', tooltip: 'Freezable' },
    { value: 'LA', text: 'Limited', icon: 'icon-limited', tooltip: 'Limited' },
    {
      value: SVG_ICON_NAME.RESUNA,
      text: 'RESUNA',
      svgIcon: SVG_ICON_NAME.RESUNA,
      tooltip: 'Unattended delivery, appt is not required.'
    },
    {
      value: 'RES',
      text: 'Residential',
      icon: 'icon-residential',
      tooltip: 'Residential'
    },
    {
      value: 'specialInstruction',
      text: 'Special Instructions',
      icon: 'icon-special-instructions',
      tooltip: 'Special Instructions'
    },
    {
      value: SVG_ICON_NAME.ExcessiveLength,
      text: 'Excessive Length',
      svgIcon: SVG_ICON_NAME.ExcessiveLength,
      tooltip: 'Excessive Length'
    },
    {
      value: 'COD',
      text: 'COD/FRT Charge',
      svgIcon: SVG_ICON_NAME.COD,
      tooltip: 'Shipment has COD, Freight Charge'
    },
    {
      value: SVG_ICON_NAME.CargoVan,
      text: 'Cargo Van',
      svgIcon: SVG_ICON_NAME.CargoVan,
      tooltip: 'Cargo Van'
    },
    { value: SVG_ICON_NAME.TwoMan, text: '2 Man', svgIcon: SVG_ICON_NAME.TwoMan, tooltip: '2 Man' },
    {
      value: SVG_ICON_NAME.TrailerBackFill,
      text: 'Trailer Drop',
      svgIcon: SVG_ICON_NAME.TrailerBackFill,
      tooltip: 'Trailer Drop'
    },
    {
      value: SVG_ICON_NAME.LiftGateOverride,
      text: 'Customer Override LG',
      svgIcon: SVG_ICON_NAME.LiftGateOverride,
      tooltip: 'Customer preference overrides shipment property'
    },
    {
      value: SVG_ICON_NAME.TrailerSwap,
      text: 'Trailer Swap',
      svgIcon: SVG_ICON_NAME.TrailerSwap,
      tooltip: 'Trailer Swap'
    },
    {
      value: SVG_ICON_NAME.LiveUnload,
      text: 'Live Unload',
      svgIcon: SVG_ICON_NAME.LiveUnload,
      tooltip: 'Live Unload'
    },
    {
      value: SVG_ICON_NAME.Hold,
      text: 'Hold Pro',
      svgIcon: SVG_ICON_NAME.Hold,
      tooltip: 'Pro is on hold'
    },
    {
      value: SVG_ICON_NAME.HoldRM,
      text: 'Hold Pro (RouteMax)',
      svgIcon: SVG_ICON_NAME.HoldRM,
      tooltip: 'Pro is on hold (RouteMax)'
    },
    {
      value: SVG_ICON_NAME.CustomerComments,
      text: 'Customer Comments',
      svgIcon: SVG_ICON_NAME.CustomerComments,
      tooltip: 'Customer Comments'
    },
    {
      value: SVG_ICON_NAME.ShipperComments,
      text: 'Shipper Comments',
      svgIcon: SVG_ICON_NAME.ShipperComments,
      tooltip: 'Shipper Comments'
    },
    {
      value: 'Unattended',
      text: 'Unattended',
      svgIcon: SVG_ICON_NAME.RESUNA,
      tooltip: 'Unattended delivery, appt is not required.'
    },
    {
      value: 'DOW',
      text: 'DOW',
      svgIcon: SVG_ICON_NAME.DOW,
      tooltip: 'DOW',
      allowedGrids: [gridNames.StopsGrid, gridNames.IBShipmentsGrid]
    },
    {
      value: SVG_ICON_NAME.WhiteGloveDelivery,
      text: 'White Glove',
      svgIcon: SVG_ICON_NAME.WhiteGloveDelivery,
      tooltip: 'White Glove Delivery',
      notAllowedGrids: [gridNames.PickupsGrid]
    },
    {
      value: SVG_ICON_NAME.NINV,
      text: 'NINV Pros',
      svgIcon: SVG_ICON_NAME.NINV,
      tooltip: 'Non-Inventory Freight',
      notAllowedGrids: [gridNames.PickupsGrid]
    },
    {
      value: SVG_ICON_NAME.PhysicalDR,
      text: 'Paper DR',
      svgIcon: SVG_ICON_NAME.PhysicalDR,
      tooltip: 'Paper Delivery Receipt Required',
      notAllowedGrids: [gridNames.PickupsGrid]
    },
    {
      value: SVG_ICON_NAME.ExhibitPickup,
      text: 'Exhibit Pros',
      svgIcon: SVG_ICON_NAME.ExhibitPickup,
      tooltip: 'Exhibit Pros',
      notAllowedGrids: [gridNames.PickupsGrid]
    },
    {
      value: SVG_ICON_NAME.ADN,
      text: 'ADN',
      svgIcon: SVG_ICON_NAME.ADN,
      tooltip: 'Advance Delivery Notification',
      notAllowedGrids: [gridNames.PickupsGrid, gridNames.ShipperGrid]
    },
    {
      value: SVG_ICON_NAME.TailLoad,
      text: 'Tail Load',
      svgIcon: SVG_ICON_NAME.TailLoad,
      tooltip: 'Tail Load',
      notAllowedGrids: [gridNames.PickupsGrid]
    },
    {
      value: SVG_ICON_NAME.Heat,
      text: 'Heat',
      svgIcon: SVG_ICON_NAME.Heat,
      tooltip: 'Heat',
      allowedGrids: [gridNames.IBShipmentsGrid]
    },
    {
      value: SVG_ICON_NAME.Fresh,
      text: 'Fresh',
      svgIcon: SVG_ICON_NAME.Fresh,
      tooltip: 'Fresh',
      allowedGrids: [gridNames.IBShipmentsGrid]
    },
    {
      value: SVG_ICON_NAME.Frozen,
      text: 'Frozen',
      svgIcon: SVG_ICON_NAME.Frozen,
      tooltip: 'Frozen',
      allowedGrids: [gridNames.IBShipmentsGrid]
    },
    { value: '', text: ' (BLANKS)' }
  ],
  SpecialNeedsExclusionList: {
    shipmentGrid: []
  },
  Colors: {
    transparent: 'transparent',
    notificationIconColor: '#CCCCCC',
    disabledColor: '#909093'
  },
  weekdayFilter: [
    {
      value: 'M',
      text: 'Monday(M)'
    },
    {
      value: 'T',
      text: 'Tuesday(T)'
    },
    {
      value: 'W',
      text: 'Wednesday(W)'
    },
    {
      value: 'R',
      text: 'Thursday(R)'
    },
    {
      value: 'F',
      text: 'Friday(F)'
    }
  ],
  UNRTD_ROUTENAME: 'UNRTD',
  FME_ROUTE_TRAILER_LENGTH: 18,
  BLANK: '(BLANKS)',
  EMPTY_STRING: '',
  DATETYPES: {
    DATE: {
      type: 'Date',
      format: 'MM/dd',
      placeholder: 'MM/DD',
      inputMask: [/\d/, /\d/, '/', /\d/, /\d/],
      updateFormat: "yyyy-MM-dd'T'00:00:00.000Z"
    },
    DATEYEAR: {
      type: 'Date',
      format: 'yy/MM/dd',
      placeholder: 'YY/MM/DD',
      inputMask: [/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/],
      updateFormat: "yyyy-MM-dd'T'00:00:00.000Z"
    },
    TIME: {
      type: 'Time',
      format: 'HH:mm',
      formatWithSeconds: 'HH:mm:ss',
      placeholder: 'HH:MM',
      inputMask: [/\d/, /\d/, ':', /\d/, /\d/],
      intervalSeperator: '-',
      updateFormat: "yyyy-MM-dd'T'HH:mm:00.000Z"
    },
    DATETIME: {
      type: 'DateTime',
      format: 'MM/dd HH:mm',
      placeholder: 'MM/DD HH:MM',
      inputMask: [/\d/, /\d/, '/', /\d/, /\d/, ' ', /\d/, /\d/, ':', /\d/, /\d/],
      updateFormat: "yyyy-MM-dd'T'HH:mm:00.000Z"
    },
    MONTHDATEYEAR: {
      type: 'Date',
      format: 'MM/dd/yy',
      placeholder: 'MM/DD/YY',
      inputMask: [/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/],
      updateFormat: "yyyy-MM-dd'T'00:00:00.000Z"
    },
    DATETIMEWITHOUTTIMEZONE: {
      format: "yyyy-MM-dd'T'00:00:00.000"
    }
  },
  ERROR_MESSAGE: {
    GRID_DATA_FETCH_FAILED: 'Something went wrong'
  },
  routeLockStates: {
    LOCK: {
      value: 2,
      text: 'Lock',
      icon: 'icon-locked',
      toolTipInfo: 'Cannot add/remove shipments to this route'
    },
    PARTIAL_LOCK: {
      value: 1,
      text: 'Partial-lock',
      icon: 'icon-partial-locked',
      toolTipInfo: 'Can only add shipments to the route'
    },
    UNLOCK: {
      value: 0,
      text: 'Unlock',
      icon: 'icon-unclock',
      toolTipInfo: 'Can add/remove shipments to the route'
    }
  },
  shipmentPlanStates: [
    { value: true, text: 'In Plan' },
    { value: false, text: 'Out of Plan' }
  ],
  STOP_MOVES: {
    RESEQUENCE: 'resequence',
    CHANGE_ROUTE: 'changeRoute',
    SINGLE_STOP_ROUTECHANGE: 'singleStopRouteChange',
    SWAP_STOP_SEQ: 'swapStopSequence',
    MARK_NEXT_STOP: 'markNextStop'
  },
  STOP_STATUS: {
    DELAYED: 'Delayed',
    ONTIME: 'On-Time',
    EARLY_ARRIVAL: 'Early Arrival'
  },
  VIOLATION_MESSAGES: {
    LATE_PROS: 'Pros arriving too late for route start time',
    NON_FME_CUSTOMER_ROUTE: 'Non FME customer present in this FME route',
    TAIL_LOAD_MULTIPLE_STOPS: 'More than one tail load stop in this route',
    TAIL_LOAD_STOP_NOT_FIRST: 'Tail load stop not the first stop in this route',
    TAIL_LOAD_NO_LOADING_ZONE_T: 'Tail load shipment not having loading zone as T'
  },
  TAIL_LOAD_FIRST_STOP_SEQUENCE: 1,
  FILTER_TYPES: {
    STRING: 'string',
    NUMBER: 'number'
  },
  DYNAMIC_ROUTING_PROGRESS_MESSAGES: [
    'Without leaving the Route Planning screen, you can move shipments between routes in either the Shipments grid or the Stops grid by using the "Edit" button.',
    'Red dots in the Routes and Stops grids (if present) indicate violations. Hold the mouse over a red dot to see the violation(s).',
    'Click the Sequence Optimizer button to put all the stops within the selected (highlighted) routes into their best order. This button will NOT move shipments between routes.',
    'To revert a bad stop move, click the Undo button in the Stop Move feedback panel. This panel slides into the top right corner, but only when the stop move has caused a significant change.',
    'Keep up to date on the latest features, tutorials & videos in the RouteMAX Help Center. Click on the Help button (just to the right of the Optimize button) and select “What’s New.”'
  ],
  APPOINTMENT_ROUTES: ['APP_1', 'APM_1', 'APT_1', 'APW_1', 'APH_1', 'APF_1'],
  ROUTE_TYPES: {
    CITY: 'City',
    TRAP: 'Trap'
  },

  ROUTE_TYPES_LIST: [
    { value: 'City', text: 'City' },
    { value: 'Trap', text: 'Trap' }
  ],

  NAV_URLS: {
    HOME: '/',
    IBPLANNING_HOME: '/ibplanning',
    IBPLANNING_SHIPMENTS: '/ibplanning/shipments',
    IBPLANNING_ROUTES: '/ibplanning/routes',
    IBPLANNING_CUSTOMERS: '/ibplanning/customers',
    SHIPMENT_SELECTION: '/shipmentselection',
    SHIPMENT_FORECAST: '/shipmentforecast',
    DISPATCH_HOME: '/dispatch',
    DISPATCH_ASSET_MANAGEMENT: '/dispatch/assetmanagement',
    DISPATCH_ROUTEEXECUTION: '/dispatch/routes',
    REPORT_HOME: '/reports',
    REPORT_IBPSUMMARY: '/reports/ibplanningsummary',
    REPORT_PUBLISH_STATUS: '/reports/publishstatus',
    REPORT_DOCK_COMPLIANCE: '/reports/dockcompliance',
    REPORT_DRIVER_PERFORMANCE: '/reports/driverperformance',
    REPORT_DRIVER_PERFORMANCE_LIVE: '/dispatch/driverperformancelive',
    REPORT_PRO_HISTORY: '/reports/prohistory',
    REPORT_KPI_SUMMARY: '/reports/kpisummary',
    REPORT_DUPLICATE_CUSTOMERS: '/reports/duplicatecustomers',
    REPORT_MERGED_CUSTOMERS: '/reports/mergedcustomers',
    REPORT_SHIPMENTS_EVENT_STREAM: '/reports/shipmentseventstream',
    REPORT_TRAILER_STRIP_PRIORITY: '/reports/trailerstrippriority',
    NEXT_STOP_COMPLIANCE: '/reports/nextstopcompliance',
    REPORT_RECORDS_lOOKUP: '/reports/recordslookup',
    REPORT_USAGE_REPORT: '/reports/usagereport',
    REPORT_ROUTE_AUDIT: '/reports/routeaudit',
    SETTINGS: '/settings',
    PAGE_NOT_FOUND: '/pageNotFound',
    SERVER_ERROR: '/serverError',
    ACCESS_DENIED: '/accessdenied',
    SUB_MODULES: {
      IBPLANNING: ['shipments', 'routes', 'customers'],
      DISPATCH: ['routes', 'assetmanagement', 'driverperformancelive'],
      REPORTS: [
        'ibplanningsummary',
        'publishstatus',
        'dockcompliance',
        'prohistory',
        'kpisummary',
        'nextstopcompliance',
        'driverperformance',
        'duplicatecustomers',
        'mergedcustomers',
        'recordslookup',
        'shipmentseventstream',
        'trailerstrippriority',
        'usagereport',
        'routeaudit'
      ]
    }
  },
  SETTINGS_MODULES: {
    ACCESSIBLE_TERMINAL: 'accessibleTerminal',
    ANCHOR_POINT: 'anchorPoint',
    DISPLAY: 'display',
    DRIVER_PREFERENCES: 'driverPreferences',
    EQUIPMENT_MOVE_TERMINALS: 'equipmentMoveTerminals',
    FEEDER_TERMINAL: 'feederTerminal',
    HOLD_PROS: 'holdPros',
    HOLIDAY_MANAGEMENT: 'holidayManagement',
    IMPORT_FILES: 'importFiles',
    KPI_GOALS: 'kpiGoals',
    NOTIFICATIONS: 'notifications',
    PARAMETERS: 'parameters',
    PROFILE: 'profile',
    ROUTE_EQUIPMENT_PREFERENCE: 'routeEquipmentPreference',
    ROUTE_MAPPING_TOOL: 'routeMappingTool',
    SCENARIO_EXPLORER: 'scenarioExplorer',
    SPEED_PROFILER: 'speedProfiler',
    TERMINAL_ACCESS: 'terminalAccess',
    TERMINAL_ONBOARDING: 'TerminalOnboarding',
    TRAILER_INVENTORY: 'trailerInventory',
    WAVES: 'waves'
  },
  ACTION: {
    FirstPush_Routes: 'Initial Route from AS400',
    IncremantalPush_Routes: 'Incremental Data Push ',
    UpdateShipmentRouteAssignment: 'Shipment Route Changed',
    ConvertRoute: 'Route Type Changed',
    UpdateRoutes: 'Route Properties Updated',
    CreateRoute: 'Route Created through internal operation in RouteMAX',
    UpdateRouteStops: 'Stop Route Changed from Data Grid',
    UpdateRouteStopsFromMap: 'Stop Route Changed from Map',
    UpdateRouteAnchorPoint: 'Anchor Point Updated for Route',
    UpdateAnchorPoint: 'Anchor Point Updated for Route',
    UpdateFirstStop: 'First Stop Updated',
    'Copy Scenario': 'Copy scenario from RouteMAX UI',
    UpdateLastStop: 'Last Stop Updated',
    RunTSP: 'Ran Sequence Optimization',
    UpdateShipmentsProperty: 'Shipment Metadata Update',
    MergeRoutes: 'Merge Routes',
    UndoVersion: 'Undo Stop move',
    'Resolve version conflict': 'Multiple actions happened on the PRO',
    UpdateStopSequence: 'Stop Sequence Changed',
    updateCustomerLocation: 'Customer Location Updated',
    IncremantalPush_Shipment: 'Shipment Metadata Update'
  },
  DCR_KPI_Mapping: {
    changedBills: 'Changed Bills',
    changedPercentage: 'Changed %',
    compliancePercentage: 'Compliance %',
    fmrtChangesSinceMorning: 'FMRT Changes',
    routeChangesSinceMorning: 'Route Changes',
    totalBills: 'Total Bills',
    totalRmaxBills: 'Total Planned Bills',
    unplannedBills: 'Unplanned Bills',
    unplannedRoutes: 'Unplanned Routes',
    unpublishedBills: 'Unpublished Bills',
    unrtdBills: 'UNRTD Bills',
    waveChangesSinceMorning: 'Wave Changes',
    totalLoadedBills: 'Total Loaded Bills',
    totalMatchedBills: 'Total Matched Bills',
    totalMissedBills: 'Total Missed Bills',
    totalPlannedBills: 'Total Planned Bills',
    totalWrongFmrtBills: 'Total Wrong FMRT Bills',
    totalExtraBills: 'Total Extra Bills'
  },
  DCR_DRILLDOWN_COMPLIANCE: 70,
  DELIVERY_CODE: {
    DC: 'DC',
    DE: 'DE',
    RTN: 'RTN',
    TA: 'TA',
    IOK: 'IOK',
    SND: 'SND'
  },
  SPECIAL_RETURNS: ['RF', 'RD', 'CNM', 'DAC', 'DAR'],
  SpecialNeedsStrings: {
    EQS: 'EQS',
    APT: 'APT',
    FD: 'FD',
    PZ: 'PZ',
    HZ: 'HZ',
    FZ: 'FZ',
    RES: 'RES',
    LA: 'LA',
    L: 'L',
    SI: 'specialInstruction',
    CC: SVG_ICON_NAME.CustomerComments,
    SC: SVG_ICON_NAME.ShipperComments,
    ExcessiveLength: SVG_ICON_NAME.ExcessiveLength,
    RESUNA: 'RESUNA',
    COD: 'COD',
    TwoMan: SVG_ICON_NAME.TwoMan,
    CargoVan: SVG_ICON_NAME.CargoVan,
    TrailerBackFill: SVG_ICON_NAME.TrailerBackFill,
    LiftGateOverride: SVG_ICON_NAME.LiftGateOverride,
    TrailerSwap: SVG_ICON_NAME.TrailerSwap,
    LiveUnload: SVG_ICON_NAME.LiveUnload,
    Hold: SVG_ICON_NAME.Hold,
    HoldRM: SVG_ICON_NAME.HoldRM,
    Unattended: 'Unattended',
    DOW: 'DOW',
    WhiteGloveDelivery: SVG_ICON_NAME.WhiteGloveDelivery,
    NINV: SVG_ICON_NAME.NINV,
    PhysicalDR: SVG_ICON_NAME.PhysicalDR,
    ExhibitPickup: SVG_ICON_NAME.ExhibitPickup,
    ADN: SVG_ICON_NAME.ADN,
    TailLoad: SVG_ICON_NAME.TailLoad,
    Fresh: SVG_ICON_NAME.Fresh,
    Heat: SVG_ICON_NAME.Heat,
    Frozen: SVG_ICON_NAME.Frozen
  },
  TEMP_TYPE: {
    HEAT: 'H',
    FROZEN: 'F',
    FRESH: 'C'
  },
  DISPATCH_DRIVER_MAP: {
    pendingDelivery: 'Pending Delivery',
    pendingPickup: 'Pending Pickup',
    completedPickup: 'Completed Pickup',
    unassigned: 'Unassigned',
    assigned: 'Assigned',
    completedDelivery: 'Completed Delivery'
  },
  GRID_STATUS: {
    LOADING: 'loading',
    SUCCESS: 'success',
    ERROR: 'error'
  },
  STOP_TYPE: {
    Delivery: 'Delivery',
    Pickup: 'Pickup'
  },
  PICKUP_STATUS: {
    COMPLETED: 'Completed',
    WAITING: 'Waiting',
    NO_FREIGHT: 'No Freight',
    PENDING: 'Pending'
  },
  EXCESSIVE_SHIPMENT_OPTIONS: [
    { statusCode: 'C', status: "Can't See" },
    { statusCode: 'Y', status: 'Yes' },
    { statusCode: 'N', status: 'No' }
  ],
  EXCESSIVE_SHIPMENT: {
    CAN_NOT_SEE: 'C',
    YES: 'Y',
    NO: 'N'
  },
  BOOLEAN_FLAG: {
    YES: 'Y',
    NO: 'N'
  },
  TRAILER_BACKFILL: {
    YES: 'Y',
    NO: ''
  },
  PICKUP_ACCESSORIAL_CODE: 'P',
  DELIVERY_STOP_PRO_PENDING_STATUS: 'PENDING',
  DELIVERY_ACCESSORIAL_CODE: 'D',
  MESSAGE_TYPE: {
    Dispatcher: 'DSP',
    Driver: 'DRV'
  },
  DELIVERY_STATUS: {
    RETURN: 'Return',
    DELIVERY_EXCEPTION: 'Delivery Exception',
    COMPLETED: 'Completed',
    PENDING: 'Pending',
    DELIVERED_CLEAR: 'Delivered clear',
    TENDERED_TO_AGENT: 'Tendered to an agent'
  },
  PICKUP_EVENTS: {
    ASSIGN_PICKUP: 'AssignPickup',
    UNASSIGN_PICKUP: 'UnassignPickup',
    UPDATE_PICKUP: 'UpdatePickup',
    SHOW_PICKUP_ASSIGNMENT_CONFIRMATION: 'ShowPickupAssignmentConfirmation',
    SHOW_PICKUP_UNASSIGNMENT_CONFIRMATION: 'ShowPickupUnassignmentConfirmation',
    SHOW_PICKUP_REASSIGNMENT_CONFIRMATION: 'ShowPickupReassignmentConfirmation'
  },
  PICKUP_TIMING_CONSTANTS: {
    TIMESTAMP_NOT_AVAILABLE: 'TIMESTAMP_NOT_AVAILABLE'
  },
  DELAY_STOP_TYPES: {
    LUNCH_BREAK: 'Lunch',
    FUEL_BREAK: 'Fuel',
    REST_BREAK: 'Rest'
  },
  REFRESH_DRIVER_DURATION: 60000, //(in milliseconds for 1 min)
  MIN_TRAILER_LENGTH: 8,
  MIN_LAST_REFRESH_THRESHOLD_TIME: 10, //(in min)
  DISPATCH_EVENTS: {
    UPDATE_DISPATCH_DRIVER_ROUTES: 'UpdateDriverRoute'
  },
  DISPATCH_TYPE: {
    TRAILER: 'trailer',
    BOBTAIL: 'bobtail'
  },
  MAP_STYLE_NAME: {
    Dark: 'Dark',
    Light: 'Light',
    Satellite: 'Satellite'
  },
  MODULES: ['Planning', 'Dispatch'],
  DUPLICATE_CUSTOMER_MODES: {
    DYNAMIC_ROUTING: 'DynamicRouting',
    STANDALONE: 'Standalone'
  },
  ONE_MINUTE_TIME_OUT: 60000, //(in milliseconds for 1 min),
  ONE_SECOND_TIME_OUT: 1000, //(in milliseconds for 1 sec),
  SEARCH_DEBOUNCE_DELAY: 300, // in ms
  features: {
    //Terminal specific feature flags
    isWeightBasedRouting: 'IsWeightBasedRoutingEnabled',
    IsStopTimeEditable: 'IsStopTimeEditable',
    EnableDispatchDriver: 'EnableDispatchDriver',
    EnableChangePickupTerminal: 'EnableChangePickupTerminal',
    EnablePickupEdit: 'EnablePickupEdit',
    EnableDispatchRouteResequence: 'EnableDispatchRouteResequence',
    EnableNextStopComplianceReport: 'EnableNextStopComplianceReport',
    EnableDropHookMove: 'EnableDropHookMove',
    CheckDigitRequired: 'CheckDigitRequired',
    EnableSpeedProfiler: 'EnableSpeedProfiler',
    EnableRouteEquipmentPreference: 'EnableRouteEquipmentPreference',
    DisableReturnToTerminalOption: 'DisableReturnToTerminalOption',
    EnableReturnToTerminalCheckedByDefault: 'EnableReturnToTerminalCheckedByDefault',
    AllowAddAnchorPoint: 'AllowAddAnchorPoint',
    EnableDriverPerformanceHistoricReport: 'EnableDriverPerformanceHistoricReport',
    EnableDoorForRouteMapping: 'EnableDoorForRouteMapping',
    AutomaticPickupRecommendation: 'AutomaticPickupRecommendation',
    EnableShipmentSelection: 'EnableShipmentSelection',
    EnableDoorForRoutesGrid: 'EnableDoorForRoutesGrid',
    EnableIBStripPriorityReport: 'EnableIBStripPriorityReport',
    EnableInputValidationForDynamicRouting: 'EnableInputValidationForDynamicRouting',
    EnableMaxTripsConstraintInDRPopup: 'EnableMaxTripsConstraintInDRPopup',
    EnableMaxStopsPerRouteInput: 'EnableMaxStopsPerRouteInput',
    EnableEnforcedDynamicRoutingFromShipmentSelection:
      'EnableEnforcedDynamicRoutingFromShipmentSelection',
    EnableDeliveryLocationMapping: 'EnableDeliveryLocationMapping',
    EnableHidePickupLoaderOnSignalR: 'EnableHidePickupLoaderOnSignalR',
    ShowTrailerScac: 'ShowTrailerScac',
    EnableDuplicateCustomerTerminalLevel: 'EnableDuplicateCustomerTerminalLevel',
    EnableCustomerDuplicateCheck: 'EnableCustomerDuplicateCheck',
    EnablePickupGrouping: 'EnablePickupGrouping',
    ShowProImagesInPopup: 'ShowProImagesInPopup',
    EnableTailLoadInCustomerManagement: 'EnableTailLoadInCustomerManagement'
  },
  gridColumnFeatureFlag: {
    DispatchedDriverGrid: {
      EnableDriverZone: 'showZones',
      EnableWeeklyAccruedHours: 'showWeeklyAccruedHours'
    }
  },
  ACCESSORIAL: {
    SORT_AND_SEGREGATE: 'SORT',
    LIMITED_ACCESS: 'LIMIT',
    LIFTGATE: 'LGATE'
  },
  PICKUP_TYPES: [
    {
      value: SVG_ICON_NAME._3PL,
      text: SVG_ICON_NAME._3PL,
      svgIcon: SVG_ICON_NAME._3PL,
      tooltip: SVG_ICON_NAME._3PL
    },
    {
      value: SVG_ICON_NAME.SWAP,
      text: SVG_ICON_NAME.SWAP,
      svgIcon: SVG_ICON_NAME.SWAP,
      tooltip: SVG_ICON_NAME.SWAP
    },
    {
      value: SVG_ICON_NAME.DockDrop,
      text: SVG_ICON_NAME.DockDrop,
      svgIcon: SVG_ICON_NAME.DockDrop,
      tooltip: SVG_ICON_NAME.DockDrop
    },
    {
      value: SVG_ICON_NAME.dailyPickup,
      text: 'Daily Pickup',
      svgIcon: SVG_ICON_NAME.dailyPickup,
      tooltip: 'Daily Pickup',
      iconStyles: {
        size: 14
      }
    },
    {
      value: SVG_ICON_NAME.ExhibitPickup,
      text: 'Exhibit Pickup',
      svgIcon: SVG_ICON_NAME.ExhibitPickup,
      tooltip: 'Exhibit Pickup',
      iconStyles: {
        size: 14
      }
    }
  ],
  PRIORITY_ICON,
  PRIORITY_SHIPMENTS_ICONS: {
    WING: PRIORITY_ICON.HIGH,
    PTY: PRIORITY_ICON.HIGH.LOW,
    SGS12: PRIORITY_ICON.HIGH, // SAIA GAURANTEED SHIPMENT BEFORE 12PM
    SGS5: PRIORITY_ICON.HIGH.LOW, // SAIA GAURANTEED SHIPMENT BEFORE 5PM
    XA: PRIORITY_ICON.HIGH.LOW,
    SOLUTION: PRIORITY_ICON.HIGH.LOW,
    NG: PRIORITY_ICON.HIGH, // known priority
    TG: PRIORITY_ICON.HIGH.LOW,
    DG: PRIORITY_ICON.HIGH.LOW // Day priority
  },
  DEFECTS_SEVERITY_CODES: {
    H: 'High',
    L: 'Low'
  },
  DEFECTS_SEVERITY_TYPES: {
    H: 'H',
    L: 'L'
  },
  LOCALES: 'en-US', //represents the code for human language that we want to format the number in
  MAP_ZOOM_LEVEL: 9,
  MAX_FEASIBLE_DRIVERS: 5,
  SNACKBAR_AUTO_HIDE_DURATION: 30000,
  EQUIPMENT_TYPES: { Trailer: 'T', Tractor: 'P', Dolly: 'D' },
  EQUIPMENT_TAB_NAME: ['Trailer', 'Tractor', 'Dolly'],
  ASSET_DOLLY_EVENT_LIST: ['AddDolly', 'UpdateDolly'],
  ASSET_TRACTOR_EVENT_LIST: ['UpdateTractor', 'AddTractor'],
  ASSET_TRAILER_EVENT_LIST: ['UpdateTrailer', 'AddTrailer'],
  INVALID_TIME_RANGE: 'Invalid_Time',
  INVALID_DATE: 'Invalid Date',
  APP_DATE_FORMAT: 'yyyy-MM-dd',
  DATE_TIME_DISPLAY_FORMAT: 'MM/dd/yy HH:mm',
  STOP_POPUP_THRESHOLD_ZOOM_LEVEL: 11,
  CLOSING_SOON_PICKUP_TYPES: {
    ALERT: 'alert',
    WARNING: 'warning',
    CLOSED: 'closed'
  },
  CUSTOMER_TAB_TYPE: {
    PICKUP: 'pickup',
    DELIVERY: 'delivery',
    HOLIDAY: 'holiday',
    DRIVER_COMMENTS: 'driverComments',
    ALIASES: 'aliases'
  },
  MERGE_STOPS_TAB_TYPE: {
    MERGE_STOPS: 'mergeStops',
    SHIPMENTS: 'shipments'
  },
  ETL_LOADER_DATE_FORMAT: 'MM-dd',
  ROUTE_STOP_TYPES: {
    DL: 'DL',
    PU: 'PU',
    AP: 'AP'
  },
  IBPLANNING_QUICKFILTER_NAMES: {
    CUSTOMER_GRID: 'CustomerManagementFilter',
    SHIPPER_GRID: 'CustomerManagementShipperFilter',
    SHIPMENT_FORECAST: 'ShipmentForecastFilter',
    SHIPMENTS_GRID: 'ShipmentManagementFilter'
  },
  CUSTOMER_TYPE: {
    PICKUP: 'pickup',
    DELIVERY: 'delivery'
  },
  SPECIAL_NEEDS_SECTION_TYPE: {
    PRINT_SECTION: 'PRINT_SECTION',
    DRAWER_SECTION: 'DRAWER_SECTION'
  },
  ADD_UPDATE_FORM_MODES: {
    ADD: 'ADD',
    UPDATE: 'UPDATE'
  },
  CUSTOM_LABELS: {
    GUARANTEED_SHIPMENT: {
      labelField: 'guaranteed',
      fallbackLabel: 'Expedite'
    }
  },
  FME_ROUTE_NAME: 'FME',
  FME_ROUTE_TRAILER_TYPES: ['StraightTruck', 'StraightTruckLG', 'FinalMile', 'FinalMileLG'],
  LINKEX_ROUTE_NAME: 'LXC', // Saia Linkex city route
  LINKEX_ROUTE_TRAILER_TYPES: ['StraightTruck', 'StraightTruckLG'], // Saia has no FinalMile inventory
  DYNAMIC_ROUTING_VALIDATION_STEPS: {
    LG_TRAILER_REQUIRED: 'LgTrailerRequiredCheck',
    DUPLICATE_CUSTOMERS: 'DuplicateCustomerCheck',
    INCORRECT_PSE: 'IncorrectPseCheck',
    LATE_SHIPMENTS: 'LateShipmentCheck',
    SHIPMENT_DISTANCE: 'DistantShipmentCheck',
    UNAPPOINTED_PROS: 'UnappointedProCheck'
  },
  KPI_REPORTS_PAST_MONTHS_LIMIT: 6,
  DEFAULT_MAX_ALLOWED_TRAILERS_COUNT: 3, // Default maximum number of trailers allowed for dispatch
  DOTTED_ROUTE: 'dotted',
  MARKER_TYPE: {
    ACTIVE: 'active',
    NON_ACTIVE: 'nonactive'
  },
  HOLD_PRO_SOURCE_ROUTEMAX: 'RouteMax',
  ADD_PRO_NOTES: {
    COMMENT_MAX_LENGTH: 6000
  },
  ROW_TYPE: {
    GROUP: 'group',
    ROW: 'row'
  },
  DOW: {
    MONDAY: { value: 'monday', icon: 'M', name: 'Monday', order: 0 },
    TUESDAY: { value: 'tuesday', icon: 'T', name: 'Tuesday', order: 1 },
    WEDNESDAY: { value: 'wednesday', icon: 'W', name: 'Wednesday', order: 2 },
    THURSDAY: { value: 'thursday', icon: 'R', name: 'Thursday', order: 3 },
    FRIDAY: { value: 'friday', icon: 'F', name: 'Friday', order: 4 },
    SATURDAY: { value: 'saturday', icon: 'S', name: 'Saturday', order: 5 },
    SUNDAY: { value: 'sunday', icon: 'U', name: 'Sunday', order: 6 }
  },
  COUNTRY_ABBREVIATION: {
    US: 'US',
    CA: 'CA'
  },
  ACCEPTABLE_CONFIDENCE_LEVELS: ['Exact', 'Good'],
  MIN_SORT_AND_SEGREGATE_PIECES: 1,
  MAX_SORT_AND_SEGREGATE_PIECES: 99999,
  SERVICE_LEVEL_MODE: {
    PICKUP: 'P',
    DELIVERY: 'D',
    PICKUP_AND_DELIVERY: 'PD'
  },
  SERVICE_LEVEL_MODE_FILTERS: {
    PICKUP_MODES: ['P', 'PD'],
    DELIVERY_MODES: ['D', 'PD']
  }
};

export default appConstants;
